import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  private timestamp: number;

  constructor() {
    const timestamp = parseInt(localStorage.getItem('cacheTimestamp'), 10);
    if (!timestamp) {
      this.invalidate();
    } else {
      this.timestamp = timestamp;
    }
  }

  public getTimestamp(): string {
    return this.timestamp.toString();
  }

  public invalidate(): void {
    this.timestamp = Date.now().valueOf();
    localStorage.setItem('cacheTimestamp', this.timestamp.toString());
  }

  
}
